import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';
import ContactUs from './contact-us';
import VModal from 'vue-js-modal';
// import {quoteModal} from './modals';

const ctaBarTop = () => {
    const ctaBar = document.querySelector('.persistent-cta--top');
    Vue.use(VModal);

    let ctaBarConstructor = () => {
        Vue.component('cta-bar-top-template', {
            data: function() {
                return {
                    title: store.state.pageTitle || '',
                    showTitle: false,
                    anchorLinks: {test: 'test'},
                    currentAnchor: null,
                    // store: store, //for testing only
                    hasAnchors: false,
                    isMobile: false,
                    scrollDir: null,
                    contactOpen: false,
                    contactOpenText: '',
                    store: store
                }
            },
            created: function(){
                window.addEventListener('scroll', this.handleScroll);
                this.handleScroll();
            },
            destroyed: function(){
                window.removeEventListener('scroll', this.handleScroll);
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                },
            },
            watch: {
                computedIsMobile: function() {
                    this.isMobile = this.computedIsMobile;
                    // this.scrollDirection();
                },
                scrollDir: function() {
                    if (this.scrollDir == "up") {
                        this.stickyNav();
                    } else if (this.scrollDir == "down") {
                        this.unstickyNav();
                    } else if (this.scrollDir == "top") {
                        this.$el.parentNode.classList.remove("active");
                    }
                },
                contactOpen: function() {
                    this.contactOpenText = this.contactOpen ? '' : this.$refs.contactBtn.querySelector('.button-text').dataset.openText; 
                }
            },
            methods: {
                handleScroll() {
                    const el = this.$parent.$el;
                    const wTop = document.documentElement.scrollTop || document.body.scrollTop;
                    const eTop = this.parentTop || el.getBoundingClientRect().top;

                    if (this.parentTop === null){
                        this.parentTop = eTop;
                    }

                    if (wTop > eTop) {
                        el.classList.add("persistent-cta--top-fixed");
                    } else {
                        el.classList.remove("persistent-cta--top-fixed");
                    }
                },
                toggleContact(e) {
                    this.contactOpen = !this.contactOpen;
                },

                // toggleModal() {
                //     this.$modal.show(
                //         quoteModal.template(),
                //         quoteModal.name, 
                //         quoteModal.options,
                //         quoteModal.events
                //     )
                // },

                setTitle() {
                    
                    if (document.querySelector('h1')) {
                        let pageTitle = document.querySelector('h1').innerText;
                        store.commit('updateTitle', pageTitle);
                        this.title = store.state.pageTitle;
                    }
                },
                detectHero() {
                    let options= {
                        root: null,
                        rootMargin: '0px',
                        threshold: 0
                    }
                    const toggleTitle = (changes) => {
                        changes.forEach(change => {
                            if (!(change.intersectionRatio > 0)) {
                                // console.log('hero NOT visible');
                                this.showTitle = true;
                            } else {
                                // console.log('hero visible');
                                this.showTitle = false;
                            }
                        })
                    }
                    let observer = new IntersectionObserver(toggleTitle, options);
                    
                    if (document.querySelector('h1')) {
                        let target = document.querySelector('h1').parentNode;
                        observer.observe(target);
                    } else {return;}

                },
                setAnchors() {
                    let anchorContainer = document.querySelectorAll('.sub-nav__list-container li a');
                    let anchors = [];
                    this.hasAnchors = anchorContainer.length > 0 ? true : false;

                    if (this.hasAnchors) {
                        // let test = '';
                        // document.addEventListener('click', () => {
                        //     console.log("clicked");
                        // });
                        anchorContainer.forEach((item, index) => {
                            anchors.push({
                                name: item.innerText,
                                key: item.getAttribute('href').substr(1)
                            });
                            // console.log(item)
                            // this.$nextTick(() => {
                            //     item.addEventListener("click", () => {
                            //         console.log("CLICKED");
                            //     }, false);

                            // })

                        });
    
                        // console.log(anchors);
                        this.anchorLinks = anchors;

                        store.commit('setPageAnchors', anchors);
                        this.$nextTick(() => {
                            this.observeAnchors();
                        })
                    }
                },
                initMobile() {
                    this.isMobile = store.state.isMobile;
                },
                scrollDirection() {
                    var scrollPos = 0;
                    var self = this;
                    function handleScroll() {
                        if (self.computedIsMobile) {
                            if ((document.body.getBoundingClientRect()).top == 0) {
                                self.scrollDir = "top";
                            } else if ((document.body.getBoundingClientRect()).top > scrollPos) {
                                EventBus.$emit('unstick-nav');
                                self.scrollDir = "up";
                                // this.stickyNav();
                            } else {
                                EventBus.$emit('stick-nav');
                                self.scrollDir = "down";
                                // this.unstickyNav();
                            }
                            scrollPos = (document.body.getBoundingClientRect()).top;
                        } else {
                            return;
                        }
                    }

                    window.addEventListener("scroll", handleScroll, true);
                    
                },
                stickyNav() {
                    if (!this.$el.parentNode.classList.contains('active')) {
                        this.$el.parentNode.classList.add("active");
                    } 
                },
                unstickyNav() {
                    this.$el.parentNode.classList.remove("active");
                },
                observeAnchors() {
                    let options = {
                        root: null,
                        rootMargin: '0px',
                        // threshold: .25
                        threshold: [0, .1, .2, .3, .4, .5, .6, .7, .8, .9, 1]
                        // more thresholds = more accuracy
                    }

                    const setCurrentAnchor = (entries) => {
                        for (let entry of entries) {
                            entry.target._intersectionHeight = entry.intersectionRect.height;
                        }
                        
                        // compare visibility of sections(all) after every intersection
                        const mostVisibleSection = targets.reduce((prev, current) => {
                        if (current._intersectionHeight > (prev ? prev._intersectionHeight : 0)) {
                            return current;
                        } else {
                            return prev;
                        }
                        }, null);
                        if (mostVisibleSection) {
                            this.currentAnchor = mostVisibleSection.dataset.id;
                        }                        
                    }

                    let observer = new IntersectionObserver(setCurrentAnchor, options);
                    let targets = [];

                    this.anchorLinks.forEach((anchor) => {
                        let target = document.querySelector(`[data-id="${anchor.key}"]`);
                        if (target) { targets.push(target); }
                    });
                    // console.log(targets);
                    targets.forEach((target) => {
                        observer.observe(target);
                    })
                }
            },
            mounted() {
                // console.log(this.$el)
                this.setTitle();
                this.detectHero();
                this.setAnchors();
                this.initMobile();
                this.scrollDirection();

                this.contactOpenText = this.$refs.contactBtn.querySelector('.button-text').dataset.openText; 
                // for opening the contact tooltip from other modules
                EventBus.$on(`open-contact`, () => {
                    this.contactOpen = true;
                });
                // for toggling the contact tooltip in the cta top bar only
                EventBus.$on('toggle-contact', () => {
                    this.toggleContact();
                })
                EventBus.$on('close-contact', () => {
                    this.contactOpen = false;
                });
            }
            
        });

        Vue.component('anchor-dropdown', {
            props: ['anchorLinks', 'showTitle', 'hasAnchors', 'isMobile', 'currentAnchor'],
            data: function() {
                return {
                    showAnchors: false,
                    dropdownAnchor: null
                    // showTopBar: true,
                }
            },
            computed: {
                computedCurrentAnchor: function() {
                    return this.currentAnchor;
                }
            },
            watch: {
                "currentAnchor": function() {
                    this.dropdownAnchor = this.currentAnchor;
                },
                // showTopBar: function() {
                //     let topBar = document.querySelector('.persistent-cta--top');
                //     if (this.isMobile) {
                //         if (this.showTopBar == true) {
                //             topBar.classList.remove('hide-bar');
                //         } else if (this.showTopBar == false) {
                //             topBar.classList.add('hide-bar');
                //         }
                //     }
                // },
                hasAnchors: function() {
                    this.detectAnchors();
                }
            },
            template: `
            <select name="pageSection" class="persistent-cta__dropdown" :anchor-links=anchorLinks v-on:change="jump" v-if="showAnchors" v-model="dropdownAnchor">
                <anchor-dropdown-item v-for="(item, index) in anchorLinks" :key="index" :data="item"/>
            </select>
            `,
            methods: {
                jump(e) {
                    // console.log("jump");
                    window.location.hash = `#${e.target.value}`;
                    // console.log(e.target.value);
                },
                detectAnchors() {
                    var subNav = document.querySelector(".sub-nav");
                    window.addEventListener("scroll", () => {
                        if (window.scrollY > subNav.offsetTop ){
                            this.showAnchors = true;
                        } else {
                            this.showAnchors = false;
                        }
                    })
                },
            },
            mounted() {
                this.$nextTick(function() {
                    if(this.hasAnchors) {
                        this.detectAnchors();
                    }
                });                
            }
        })

        Vue.component('anchor-dropdown-item', {
            props: ['data'],
            template: `
                <option :value="data.key">{{data.name}}</option>
            `,
        });

        ContactUs();

        new Vue({
            el: '.persistent-cta--top',
            store: store,
        }).$mount('.persistent-cta--top', true);
    }

    if(ctaBar) {
        ctaBarConstructor();
    } 

}

export default ctaBarTop;
